import * as d3 from 'd3';

// Practically all this code comes from https://github.com/alangrafu/radar-chart-d3
// I only made some additions and aesthetic adjustments to make the chart look better
// (of course, that is only my point of view)
// Such as a better placement of the titles at each line end,
// adding numbers that reflect what each circular level stands for
// Not placing the last level and slight differences in color
//
// For a bit of extra information check the blog about it:
// http://nbremer.blogspot.nl/2013/09/making-d3-radar-chart-look-bit-better.html

export default {
  draw(el, d, options) {
    const cfg = {
      w: options.w,
      h: options.h,
      factor: 0.82,
      factorLegend: 0.85,
      levels: 3,
      maxValue: 1.3,
      radians: 2 * Math.PI,
      opacityArea: 1.0,
      ToRight: 0,
      TranslateX: 0,
      TranslateY: 0,
      ExtraWidthX: 0,
      ExtraWidthY: 0,
      axisLine: false,
      axisText: true,
      circles: false,
      radius: options.radius || 0,
      colors: options.colors,
    };

    let allAxis = [];
    if (d[0]) {
      allAxis = d[0].map(i => i.axis);
    }
    const total = allAxis.length;

    d3.select(el)
      .select('svg')
      .remove();

    const g = d3
      .select(el)
      .append('svg')
      .attr('preserveAspectRatio', 'xMinYMin meet')
      .attr('viewBox', '0 0 400 400')
      .append('g')
      .attr(
        'transform',
        `translate(${cfg.TranslateX},${cfg.TranslateY}) rotate(-20 ${cfg.w / 2} ${cfg.h / 2})`
      );

    let series = 0;

    const axis = g
      .selectAll('.axis')
      .data(allAxis)
      .enter()
      .append('g')
      .attr('class', 'axis');

    axis
      .append('line')
      .attr('x1', cfg.w / 2)
      .attr('y1', cfg.h / 2)
      .attr('x2', (d, i) => (cfg.w / 2) * (1 - cfg.factor * Math.sin((i * cfg.radians) / total)))
      .attr('y2', (d, i) => (cfg.h / 2) * (1 - cfg.factor * Math.cos((i * cfg.radians) / total)))
      .attr('class', 'line')
      .style('stroke', '#ffffff')
      .style('opacity', '0.1')
      .style('stroke-width', '1px');

    let dataValues = [];

    d.forEach(y => {
      dataValues = [];
      g.selectAll('.nodes').data(y, (j, i) =>
        dataValues.push([
          (cfg.w / 2) *
            (1 -
              (parseFloat(Math.max(j.value, 0)) / cfg.maxValue) *
                cfg.factor *
                Math.sin((i * cfg.radians) / total)),
          (cfg.h / 2) *
            (1 -
              (parseFloat(Math.max(j.value, 0)) / cfg.maxValue) *
                cfg.factor *
                Math.cos((i * cfg.radians) / total)),
        ])
      );
      dataValues.push(dataValues[0]);
      const currentChart = g
        .selectAll('.area')
        .data([dataValues])
        .enter()
        .append('polygon')
        .attr('class', `radar-chart-serie${series}`)
        .attr('points', d => {
          let str = '';
          for (let pti = 0; pti < d.length; pti++) {
            str = `${str + d[pti][0]},${d[pti][1]} `;
          }
          return str;
        });

      if (series === 0) {
        currentChart.style('fill', 'url(#chartBgGradient)');
      } else {
        currentChart.style('fill', cfg.colors[series].color);
        if (cfg.colors[series].isActive) {
          currentChart.style('fill-opacity', cfg.opacityArea);
        } else {
          currentChart.style('fill-opacity', 0);
        }
      }

      currentChart.transition().duration(5050);

      series++;
    });
    series = 0;

    d.forEach(y => {
      if (series > 0) {
        g.selectAll('.nodes')
          .data(y)
          .enter()
          .append('svg:circle')
          .attr('class', `radar-chart-serie${series}`)
          .attr('r', cfg.radius)
          .attr('alt', j => Math.max(j.value, 0))
          .attr('cx', (j, i) => {
            dataValues.push([
              (cfg.w / 2) *
                (1 -
                  (parseFloat(Math.max(j.value, 0)) / cfg.maxValue) *
                    cfg.factor *
                    Math.sin((i * cfg.radians) / total)),
              (cfg.h / 2) *
                (1 -
                  (parseFloat(Math.max(j.value, 0)) / cfg.maxValue) *
                    cfg.factor *
                    Math.cos((i * cfg.radians) / total)),
            ]);
            return (
              (cfg.w / 2) *
              (1 -
                (Math.max(j.value, 0) / cfg.maxValue) *
                  cfg.factor *
                  Math.sin((i * cfg.radians) / total))
            );
          })
          .attr(
            'cy',
            (j, i) =>
              (cfg.h / 2) *
              (1 -
                (Math.max(j.value, 0) / cfg.maxValue) *
                  cfg.factor *
                  Math.cos((i * cfg.radians) / total))
          )
          .attr('data-id', j => j.axis)
          .style('fill', '#D8D8D8') // cfg.color(series))
          .style('fill-opacity', 0.9)
          .append('svg:title')
          .text(j => Math.max(j.value, 0));
      }

      series++;
    });
  },
};
